<template>
  <div >
    <!-- Title -->
    <h1 class="common-header">{{ $t('invite_15') }}</h1>
    <!-- 内容 -->
    <div class="by-content">
      <h1 @click="goBack" class="content-title"><i class="el-icon-arrow-left "></i> {{ $t('72') }}</h1>
      <el-tabs v-model="activeProbation" @tab-click="handleClick">
        <el-tab-pane :label="$t('invite_16')" name="REGULAR_NOTICE_DAY" class="remind-wrap">
          <div class="remind">
            <h2>{{ $t('invite_18') }}</h2>
            <div class="remind-content">
              <p>
                {{ $t('invite_19') }}
                <el-input
                  v-model.number="content"
                  @input="content = String(content).replace(/[^\d]/g,'')"
                  placeholder=""
                  :disabled="isDisabled"
                  @blur="handleContent"
                  clearable />
                {{ $t('invite_20') }}
              </p>
              <!-- 编辑 -->
              <el-button size="small" type="primary"  @click="onEdit">{{ isSet ? $t('71') : $t('1907') }}</el-button>
            </div>
          </div>
          <!-- 添加提醒 -->
          <el-button class="remind-btn" size="small" type="primary" @click="onAddRemind(false)">{{ $t('invite_21') }}</el-button>
          <!-- 表格内容 -->
          <el-table :data="query.tableData">
            <!-- 提醒标题-->
            <el-table-column prop="name" :label="$t('invite_27')" ></el-table-column>
            <!-- 提醒时间-->
            <el-table-column prop="notice_time" :label="$t('invite_23')" >
              <template slot-scope="scope">
                <p v-for="(item, index) in scope.row.notice_time_txt" :key="index">
                  {{ item }}
                </p>
              </template>
            </el-table-column>
            <!-- 通知对象-->
            <el-table-column prop="notice_to" :label="$t('invite_24')" >
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.notice_to_txt" :key="index">
                  {{ item }}
                  <template v-if="index !== scope.row.notice_to.length-1">, </template>
                </span>
              </template>
            </el-table-column>
            <!-- 通知方式-->
            <el-table-column prop="notice_type" :label="$t('invite_25')">
              <template slot-scope="scope">
                <template v-if="!scope.row.send.length">- -</template>
                <template v-else>
                  <span v-for="(item, index) in scope.row.send_txt" :key="index">
                    {{ item }}
                    <template v-if="index !== scope.row.send.length-1">, </template>
                  </span>
                </template>
              </template>
            </el-table-column>
            <!-- 状态-->
            <el-table-column prop="job_title_name" :label="$t('136')">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.is_on" @change="switchNotice(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <!-- 操作-->
            <el-table-column :label="$t('70')" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="onAddRemind(scope.row)">{{ $t('71') }}</el-button>
                <el-button type="text" @click="onDelRemind(scope.row)">{{ $t('65') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Pagination
            layout="total, sizes, prev, pager, next"
            :page-sizes="pageSizes"
            :total="query.total"
            :current-page="query.page"
            :page-size="query.page_size"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle" ></Pagination>
        </el-tab-pane>
        <el-tab-pane :label="$t('invite_17')" name="STAFF_PROBATION_DAY">
          <div class="remind">
            <h2>
              {{ $t('invite_43') }}
              <p class="remind-tip">{{ $t('invite_54') }}</p>
            </h2>
            <div class="remind-content">
              <p>
                {{ $t('invite_55') }}
                <el-input
                  v-model.number="content"
                  @input="content = String(content).replace(/[^\d]/g,'')"
                  placeholder=""
                  :disabled="isDisabled"
                  clearable />
              </p>
              <!-- 编辑 -->
              <el-button size="small" type="primary"  @click="onEdit">{{ isSet ? $t('71') : $t('1907') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <SetRemind ref="set-remind" @noticeConfig="getData(1)"></SetRemind>
  </div>
</template>

<script>
import {
  noticeConfigLists, // 提醒消息列表
  setRegularEnv, // 设置转正日期、提醒日期
  getRegularEnv, // 获取转正日期、提醒日期
  switchNoticeConfig, // 修改提醒状态
  delNoticeConfig // 删除提醒
} from 'api/dashboard'
import SetRemind from './setRemind' // 编辑、添加提醒
import Pagination from '@/components/pagination'
export default {
  components: {
    SetRemind,
    Pagination
  },
  data() {
    return {
      activeProbation: this.$route.query.name || 'REGULAR_NOTICE_DAY', // 试用期提醒 试用期时长设置
      isSet: true, // 转正日期前X天提醒 输入框状态
      isDisabled: true,
      content: '',
      content1: '',
      pageSizes: [20, 50, 100],
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        tableData: []
      }
    }
  },
  mounted() {
    this.handleClick()
  },
  methods: {
    getData(val) {
      this.query.page = val || this.query.page
      const { page, page_size } = this.query
      noticeConfigLists({ page, page_size }).then(res => {
        if (res && res.code === 1) {
          res.data.list.forEach(item => {
            item.is_on = item.is_on === '1'
          })
          this.query.tableData = res.data.list
          this.query.total = res.data.page_data.total
        }
      })
    },
    sizeChangeHandle(v) {
      this.query.page_size = v
      this.getData(1)
    },
    currentChangeHandle(v) {
      this.getData(v)
    },
    handleClick() {
      this.isDisabled = true
      this.content = 30
      // 获取转正日期、提醒日期
      getRegularEnv({ code: this.activeProbation }).then(res => {
        if (res && res.code) {
          this.content = res.data
          this.content1 = !this.content ? '' : this.content
        }
      })
      if (this.activeProbation === 'REGULAR_NOTICE_DAY') this.getData(1)
    },
    goBack() { // 返回
      // if (this.$route.query.name) this.$router.push({ path: '/staff/pemploymenter' })
      // else this.$emit('goBack')
      this.$router.back()
    },
    handleContent() {
      this.content = this.content ? this.content : '0'
    },
    async onEdit() { // 编辑
      this.isSet = !this.isSet
      this.isDisabled = false
      if (this.isSet) {
        setRegularEnv({ code: this.activeProbation, content: this.content }).then(res => {
          if (res && res.code === 1) {
            this.$message({
              type: 'success',
              message: this.$t('781')
            })
          }
        })
          .finally(() => {
            this.isDisabled = true
          })
      }
    },
    onAddRemind(row) { // 添加提醒
      this.$refs['set-remind'].init(row)
    },
    switchNotice(row) { // 修改提醒状态
      switchNoticeConfig({
        id: row.id,
        is_on: row.is_on ? '1' : '2'
      })
    },
    onDelRemind(row) {
      this.$confirm(this.$t('invite_56'), this.$t('prompt'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        delNoticeConfig({ id: row.id }).then(res => {
          this.$message.success(res.message)
          this.getData(1)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-title {
    cursor: pointer;
  }
  .remind {
    border: 1px solid #ebebeb;
    padding: 10px 24px;
    h2 {
      font-weight: 500;
      padding-bottom: 20px;
    }
    &-content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      align-items: center;
      .el-input {
        margin: 0 10px;
      }
    }
    &-btn {
      margin: 10px;
    }
  }
/deep/ .input-number {
  .el-input-number__decrease {
    display: none;
  }
  .el-input-number__increase {
    display: none;
  }
  .el-input__inner {
    text-align: left;
    padding: 0 15px;
  }
}
</style>
